import { OrganogramaItem } from "../../../../interfaces/ClienteEquipe";

export interface NoOrganograma {
  item: OrganogramaItem;
  filhos: NoOrganograma[];
}

const porNome = (a: OrganogramaItem, b: OrganogramaItem) => a.nome.localeCompare(b.nome, "pt-BR");

/**
 * Monta a árvore a partir da lista plana. Quem não tem gestor, ou cujo gestor não está na lista
 * (ex.: vínculo desativado), vai para a raiz. Ciclo não deveria existir (o servidor recusa), mas
 * se vier, os nós dele sobem para a raiz em vez de sumirem ou travarem a tela.
 */
export function montarArvore(itens: OrganogramaItem[]): NoOrganograma[] {
  const nos = new Map<number, NoOrganograma>();
  itens.forEach((item) => nos.set(item.vinculoId, { item, filhos: [] }));

  const alcancaRaiz = (inicio: OrganogramaItem): boolean => {
    const visto = new Set<number>();
    let atual: OrganogramaItem | undefined = inicio;
    while (atual) {
      if (visto.has(atual.vinculoId)) return false;
      visto.add(atual.vinculoId);
      if (atual.gestorVinculoId == null || !nos.has(atual.gestorVinculoId)) return true;
      atual = nos.get(atual.gestorVinculoId)!.item;
    }
    return true;
  };

  const raizes: NoOrganograma[] = [];
  [...itens].sort(porNome).forEach((item) => {
    const no = nos.get(item.vinculoId)!;
    const gestor = item.gestorVinculoId != null ? nos.get(item.gestorVinculoId) : undefined;
    if (gestor && alcancaRaiz(item)) gestor.filhos.push(no);
    else raizes.push(no);
  });
  return raizes;
}
